import { HomePlusOutlineIcon } from './HomePlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id CDAF170C-BB2C-4217-9B96-D99EE9B725F9
 * name home-plus-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-plus-outline.svg
 * tags
 * - Home Automation 
 */
export const HousePlusOutlineIcon = HomePlusOutlineIcon;
export default HousePlusOutlineIcon